import {
  Drawer,
  MenuItem,
  MenuList,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useTranslation } from '../../../contexts/TranslationContext';
import { MHMTypography } from '../MHM/MHMTypography';
import { NAVBAR_HEIGHT } from '../navbar/Navbar';
import { FOOTER_HEIGHT } from '../Footer';

const links = [
  { hash: '#frequencies', label: 'Frequencies' },
  { hash: '#low_power_mode', label: 'Low Power Mode' },
  { hash: '#battery_life', label: 'Battery Life' },
  { hash: '#api_docs', label: 'API Docs' },
  { hash: '#manuals', label: 'Manuals' },
  { hash: '#weather_mode', label: 'Weather Mode' },
  { hash: '#label', label: 'Labels' },
  { hash: '#account', label: 'Account' },
  { hash: '#alert', label: 'Alerts' },
];

const DRAWER_WIDTH = 240;

export function SettingsHeader(props: { children?: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <Toolbar
      sx={{
        py: 1,
        bgcolor: 'highlightedBackground.main',
        borderBottom: '1px solid',
        borderColor: 'lightgrey',
        borderRadius: '5px 5px 0 0',
        position: 'sticky',
        top: 0,
      }}
    >
      <MHMTypography variant="h5" component="h2" bold sx={{ mr: 'auto' }}>
        {t('Settings')}
      </MHMTypography>
      {props.children}
    </Toolbar>
  );
}

export function SettingsNav(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { open, setOpen } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Drawer
      open={open}
      variant={isMobile ? 'temporary' : 'permanent'}
      onClose={() => setOpen(false)}
      sx={{
        'display': { xs: 'block' },
        'width': { xs: '100%', sm: DRAWER_WIDTH },
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: DRAWER_WIDTH,
          pt: `${NAVBAR_HEIGHT}px`,
          pb: `${FOOTER_HEIGHT}px`,
        },
      }}
      slotProps={{
        paper: { sx: { zIndex: 0 } },
      }}
    >
      <SettingsHeader />
      <MenuList>
        {links.map(({ hash, label }, index) => (
          <MenuItem
            key={hash}
            component="a"
            href={hash}
            divider={index !== links.length - 1}
            sx={{ px: 1 }}
            onClick={() => {
              if (isMobile) {
                setOpen(false);
              }
            }}
          >
            <MHMTypography medium>{t(label)}</MHMTypography>
          </MenuItem>
        ))}
      </MenuList>
    </Drawer>
  );
}
